/**
 * Tayyib Chat API client — calls the Lambda-based chat endpoint.
 * Replaces the AgentCore SSE streaming client.
 */

export interface ChatResponse {
  response: string
  cached: boolean
  error?: string
}

export class TayyibChatClient {
  private apiUrl: string

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl.endsWith("/") ? apiUrl : apiUrl + "/"
  }

  async sendMessage(
    message: string,
    sessionId: string,
    idToken: string
  ): Promise<ChatResponse> {
    const response = await fetch(this.apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: idToken,
      },
      body: JSON.stringify({ message, sessionId }),
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`API error ${response.status}: ${errorText}`)
    }

    return response.json()
  }
}
